(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["select-item"] = factory(require("react"), require("react-dom"));
	else
		root["select-item"] = factory(root["react"], root["react-dom"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js?sourceMap!../node_modules/postcss-loader/lib/index.js??ref--1-2!../node_modules/resolve-url-loader/index.js!./select-item.css", function() {
			var newContent = require("!!../node_modules/css-loader/index.js?sourceMap!../node_modules/postcss-loader/lib/index.js??ref--1-2!../node_modules/resolve-url-loader/index.js!./select-item.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(2);

var _reactDom2 = _interopRequireDefault(_reactDom);

__webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var idInc = 0;

var keyHandlers = {
  38: 'handleUpKey',
  40: 'handleDownKey',
  32: 'handleSpaceKey',
  13: 'handleEnterKey',
  27: 'handleEscKey',
  74: 'handleDownKey',
  75: 'handleUpKey'
};

function interceptEvent(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
}

var SelectItem = function (_React$Component) {
  _inherits(SelectItem, _React$Component);

  function SelectItem(props) {
    _classCallCheck(this, SelectItem);

    var _this = _possibleConstructorReturn(this, (SelectItem.__proto__ || Object.getPrototypeOf(SelectItem)).call(this, props));

    _this.handleFocus = function () {
      clearTimeout(_this.blurTimeout);
    };

    _this.handleSearchBlur = function () {
      var menuNode = _reactDom2.default.findDOMNode(_this.menuRef);
      _this.setState({ searchVisible: false });
      if (document.hasFocus(menuNode)) {
        return _this.handleClose();
      }
    };

    _this.handleBlur = function () {
      clearTimeout(_this.blurTimeout);
      _this.blurTimeout = setTimeout(_this.handleClose, 0);
    };

    _this.handleMouseDown = function () {
      _this.clickingOption = true;
    };

    _this.handleChange = function (val, cb) {
      return function (event) {
        _this.clickingOption = false;
        interceptEvent(event);
        if (_this.isMultiple()) {
          var selected = [];
          if (val !== null) {
            selected = _this.value().slice(0);
            var index = selected.indexOf(val);
            if (index !== -1) {
              selected.splice(index, 1);
            } else {
              selected.push(val);
            }
          }
          _this.updatePendingValue(selected, cb) || _this.props.onChange(selected);
          if (_this.state.searchEnabled) {
            _this.setState({ open: true });
          }
        } else {
          _this.updatePendingValue(val, cb) || _this.props.onChange(val);
          _this.handleClose();
          if (!_this.state.searchEnabled) {
            _this.buttonRef.focus();
          }
        }
      };
    };

    _this.handleNativeChange = function (event) {
      var val = event.target.value;
      if (_this.isMultiple()) {
        var children = [].slice.call(event.target.childNodes, 0);
        val = children.reduce(function (memo, child) {
          if (child.selected) {
            memo.push(child.value);
          }
          return memo;
        }, []);
      }
      _this.props.onChange(val);
    };

    _this.handleClear = function (event) {
      interceptEvent(event);
      _this.handleChange(null, function () {
        // only called when change="true"
        this.props.onChange(this.state.pendingValue);
      })(event);
      _this.handleClose(event);
    };

    _this.toggleOpenClose = function (event) {
      interceptEvent(event);
      _this.setState({ open: !_this.state.open });
      if (_this.state.open) {
        return _this.setState({ open: false, searchVisible: false });
      }

      _this.handleOpen();
    };

    _this.handleOpen = function (event) {
      interceptEvent(event);
      _this.setState({ open: true, searchVisible: _this.state.searchEnabled }, function () {
        if (this.state.searchEnabled) {
          this.searchInputRef.focus();
        } else {
          this.menuRef.focus();
        }
      });
    };

    _this.handleClose = function (event) {
      interceptEvent(event);
      if (!_this.clickingOption) {
        _this.setState({ open: false, searchVisible: false, focusedIndex: -1 });
      }
      if (_this.changeOnClose()) {
        _this.props.onChange(_this.state.pendingValue);
      }
    };

    _this.handleKeyDown = function (event) {
      if (_this.state.searchEnabled && [27, 38, 40, 13].indexOf(event.which) === -1) {
        return;
      }
      if (keyHandlers[event.which]) {
        _this[keyHandlers[event.which]](event);
      }
    };

    _this.handleUpKey = function (event) {
      interceptEvent(event);
      _this.moveFocus(-1);
    };

    _this.handleDownKey = function (event) {
      interceptEvent(event);
      if (!_this.state.open) {
        _this.handleOpen(event);
      }
      _this.moveFocus(1);
    };

    _this.handleSpaceKey = function (event) {
      if (_this.state.searchEnabled) {
        return;
      }
      interceptEvent(event);
      if (!_this.state.open) {
        _this.handleOpen(event);
      } else if (_this.state.focusedIndex !== -1) {
        _this.handleEnterKey();
      }
    };

    _this.handleEnterKey = function (event) {
      if (_this.state.focusedIndex !== -1) {
        _this.handleChange(_this.options()[_this.state.focusedIndex].value)(event);
      }
    };

    _this.handleEscKey = function (event) {
      if (_this.state.open) {
        _this.handleClose(event);
      } else {
        _this.handleClear(event);
      }
    };

    _this.renderNativeSelect = function () {
      var id = _this.state.id + '-native-select';
      var multiple = _this.isMultiple();
      var empty = multiple ? null : _react2.default.createElement(
        "option",
        { key: "empty", disabled: true },
        "No Selection"
      );
      var options = [empty].concat(_this.props.children);
      var selectProps = {
        id: id,
        multiple: multiple,
        onKeyDown: function onKeyDown(e) {
          e.stopPropagation();
        },
        value: _this.props.value || (multiple ? [] : ''),
        onChange: _this.handleNativeChange
      };
      return _react2.default.createElement(
        "div",
        { className: "react-select-item-native" },
        _react2.default.createElement(
          "label",
          { htmlFor: id },
          _this.props.label
        ),
        _react2.default.createElement(
          "select",
          selectProps,
          options
        )
      );
    };

    _this.renderDefaultButton = function () {

      var buttonProps = {
        id: _this.state.id,
        ref: function ref(_ref) {
          return _this.buttonRef = _ref;
        },
        className: 'react-select-item',
        onClick: _this.toggleOpenClose,
        onBlur: _this.handleBlur,
        tabIndex: '0',
        'aria-hidden': true
      };

      return _react2.default.createElement(
        "button",
        buttonProps,
        _react2.default.createElement(
          "div",
          { className: "react-select-item-label" },
          _this.label()
        )
      );
    };

    _this.renderSearchButton = function () {
      if (_this.state.searchVisible) {
        return _this.renderSearchInput();
      }

      var buttonProps = {
        id: _this.state.id,
        ref: function ref(_ref2) {
          return _this.buttonRef = _ref2;
        },
        className: 'react-select-item',
        onClick: _this.handleOpen,
        onBlur: _this.handleBlur,
        tabIndex: '0',
        'aria-hidden': true
      };

      return _react2.default.createElement(
        "button",
        buttonProps,
        _react2.default.createElement(
          "div",
          { className: "react-select-item-label" },
          _this.label()
        )
      );
    };

    _this.renderSearchInput = function () {
      var inputProps = {
        id: _this.state.id + '-search',
        ref: function ref(_ref3) {
          return _this.searchInputRef = _ref3;
        },
        value: _this.state.searchText,
        className: 'react-select-item',
        onFocus: _this.handleFocus(),
        onChange: function onChange(e) {
          _this.setState({
            searchText: e.currentTarget.value
          });
        },
        onBlur: _this.handleSearchBlur,
        tabIndex: '0',
        'type': "text",
        'aria-hidden': true
      };
      return _react2.default.createElement("input", inputProps);
    };

    _this.renderOptionMenu = function () {
      var className = 'react-select-item-options';
      var selectOptions = _this.options();
      if (!_this.state.open) {
        className += ' react-select-item-hidden';
      }

      var divProps = {
        className: className,
        onBlur: _this.handleBlur,
        onFocus: _this.handleFocus,
        'aria-hidden': true,
        ref: function ref(_ref4) {
          return _this.menuRef = _ref4;
        },
        tabIndex: 0
      };

      return _react2.default.createElement(
        "div",
        divProps,
        _react2.default.createElement(
          "div",
          { className: 'react-select-item-off-screen' + (selectOptions.length === 0 ? ' no-items' : '') },
          selectOptions.length > 0 ? selectOptions.map(_this.renderOption) : _this.props.noItemsText
        ),
        _this.renderCloseButton()
      );
    };

    _this.renderOption = function (option, i) {
      var className = 'react-select-item-option';
      if (i === _this.state.focusedIndex) {
        className += ' react-select-item-option-focused';
      }
      if (_this.isSelected(option.value)) {
        className += ' react-select-item-option-selected';
      }
      if (option.disabled) {
        className += ' react-select-item-option-disabled';
      }
      var aProps = {
        id: _this.state.id + '-' + i,
        onClick: option.disabled ? function (e) {
          return interceptEvent(e);
        } : _this.handleChange(option.value),
        onMouseDown: _this.handleMouseDown,
        className: className,
        tabIndex: -1,
        onBlur: _this.handleBlur,
        onFocus: _this.handleFocus
      };

      return _react2.default.createElement(
        "a",
        _extends({ key: i }, aProps),
        option.label
      );
    };

    _this.renderClearButton = function () {
      if (_this.hasValue()) {
        var brnProps = {
          'aria-label': _this.props.clearText,
          className: 'react-select-item-clear',
          onClick: _this.handleClear
        };
        return _react2.default.createElement("button", brnProps);
      }
    };

    _this.renderCloseButton = function () {
      if (_this.isMultiple() && _this.props.closeText) {
        var btnProps = {
          onClick: _this.handleClose,
          className: 'react-select-item-close',
          onBlur: _this.handleBlur,
          onFocus: _this.handleFocus
        };
        return _react2.default.createElement(
          "button",
          btnProps,
          _this.props.closeText
        );
      }
    };

    _this.clickingOption = false;
    _this.blurTimeout = null;
    _this.state = {
      id: 'react-select-item-' + ++idInc,
      open: false,
      focusedIndex: -1,
      pendingValue: [],
      searchVisible: false,
      searchEnabled: typeof _this.props.filterFn === 'function',
      searchText: ""
    };
    return _this;
  }

  _createClass(SelectItem, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.updatePendingValue(this.props.value);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(next) {
      this.updatePendingValue(next.value);
    }
  }, {
    key: "changeOnClose",
    value: function changeOnClose() {
      return this.isMultiple() && String(this.props.changeOnClose) === 'true';
    }
  }, {
    key: "updatePendingValue",
    value: function updatePendingValue(value, cb) {
      if (this.changeOnClose()) {
        this.setState({ pendingValue: value }, cb);
        return true;
      }
      return false;
    }
  }, {
    key: "moveFocus",
    value: function moveFocus(move) {
      var len = _react2.default.Children.count(this.props.children);
      var idx = (this.state.focusedIndex + move + len) % len;
      this.setState({ focusedIndex: idx });
    }
  }, {
    key: "label",
    value: function label() {
      var _this2 = this;

      var selected = this.options().filter(function (option) {
        return _this2.isSelected(option.value);
      }).map(function (option) {
        return option.label;
      });

      return selected.length > 0 ? selected.join(', ') : this.props.label;
    }
  }, {
    key: "isMultiple",
    value: function isMultiple() {
      return String(this.props.multiple) === 'true';
    }
  }, {
    key: "isSearchable",
    value: function isSearchable() {
      return this.state.searchEnabled;
    }
  }, {
    key: "options",
    value: function options() {
      var _this3 = this;

      var options = [];
      _react2.default.Children.forEach(this.props.children, function (option) {
        options.push({
          value: option.props.value,
          label: option.props.children,
          disabled: !!option.props.disabled
        });
      });

      if (this.state.searchEnabled && this.state.searchText.length > 0) {
        return options.filter(function (item) {
          return _this3.props.filterFn(_this3.state.searchText, item);
        });
      } else {
        return options;
      }
    }
  }, {
    key: "value",
    value: function value() {
      var value = this.changeOnClose() ? this.state.pendingValue : this.props.value;

      if (!this.isMultiple() || Array.isArray(value)) {
        return value;
      }
      if (value !== null) {
        return [value];
      }
      return [];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      if (this.isMultiple()) {
        return this.value().length > 0;
      }
      return this.value() !== null;
    }
  }, {
    key: "isSelected",
    value: function isSelected(value) {
      if (this.isMultiple()) {
        return this.value().indexOf(value) !== -1;
      }
      return this.value() === value;
    }
  }, {
    key: "render",
    value: function render() {
      var className = 'react-select-item-container';
      if (this.props.className) {
        className += ' ' + this.props.className;
      }
      if (this.isMultiple()) {
        className += ' react-select-item-multi';
      }
      if (!this.hasValue()) {
        className += ' react-select-item-empty';
      }
      return _react2.default.createElement(
        "div",
        { onKeyDown: this.handleKeyDown, className: className },
        this.isSearchable() ? this.renderSearchButton() : this.renderDefaultButton(),
        this.renderOptionMenu(),
        this.renderClearButton(),
        this.renderNativeSelect()
      );
    }
  }]);

  return SelectItem;
}(_react2.default.Component);

SelectItem.defaultProps = {
  closeText: 'Close',
  clearText: 'Remove selection'
};
exports.default = SelectItem;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(true);
// imports


// module
exports.push([module.i, ".react-select-item-container {\n  position: relative;\n  width: 240px;\n  display: inline-block;\n  background-color: #fff;\n  border-radius: 4px;\n  text-align: left;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .3);\n}\n\n.react-select-item {\n  padding: 15px 0;\n  display: inline-block;\n  cursor: pointer;\n  border: none;\n  width: 100%;\n  text-align: left;\n  background-color: transparent;\n}\n\ninput.react-select-item {\n  box-sizing: border-box;\n  padding-left: 15px;\n  color: #7B8E9B;\n  background: url(" + __webpack_require__(7) + ") no-repeat scroll 9px 15px;\n  padding-left: 30px;\n}\n\n.react-select-item:focus {\n  outline: 0;\n  box-shadow: 0 0 4px #0493D1;\n}\n\n.react-select-item:before {\n  content: ' ';\n  z-index: 1;\n  position: absolute;\n  height: 20px;\n  top: 15px;\n  right: 34px;\n  border-left: 1px solid #CBD2D7;\n}\n\n.react-select-item:after {\n  content: ' ';\n  position: absolute;\n  z-index: 1;\n  top: 23px;\n  right: 13px;\n  border-top: 6px solid #7B8E9B;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n\n.react-select-item-label,\n.react-select-item-option {\n  line-height: 16px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #7B8E9B;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.react-select-item-label {\n  padding: 0 40px 0 20px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #0493D1;\n}\n\n.react-select-item-empty .react-select-item-label {\n  color: #7B8E9B;\n}\n\n.react-select-item-click-outside-layer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2;\n}\n\n.react-select-item-clear {\n  position: absolute;\n  top: 15px;\n  right: 0;\n  width: 35px;\n  height: 20px;\n  background-color: #fff;\n  text-indent: -9999em;\n  z-index: 3;\n  border: none;\n}\n\n.react-select-item-clear:before {\n  content: '\\D7';\n  position: absolute;\n  top: 2px;\n  left: 10px;\n  z-index: 1;\n  background-color: #7B8E9B;\n  border-radius: 100%;\n  font-size: 13px;\n  color: #fff;\n  line-height: 1.1;\n  width: 14px;\n  height: 14px;\n  text-indent: 0;\n  text-align: center;\n}\n\n.react-select-item-clear:hover,\n.react-select-item-clear:focus {\n  outline: 0;\n  cursor: pointer;\n}\n\n.react-select-item-clear:hover:before,\n.react-select-item-clear:focus:before {\n  background-color: #0493D1;\n}\n\n.react-select-item-hidden {\n  display: none;\n}\n\n.react-select-item-options {\n  margin: 2px 0 0;\n  position: absolute;\n  padding: 10px 0;\n  width: 240px;\n  top: 100%;\n  left: 0;\n  z-index: 4;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .3);\n}\n\n.react-select-item-options-list {\n  list-style: none outside;\n  margin: 0;\n  padding: 0;\n}\n\n.react-select-item-option {\n  padding: 10px 20px;\n  margin: 0;\n  cursor: pointer;\n  display: block;\n  line-height: 1.2;\n  text-decoration: none;\n}\n\n.react-select-item-option-disabled {\n  background: #f9f9f9;\n  color: #d0d0d0;\n}\n\n.react-select-item-option-disabled:hover {\n  background: #f9f9f9;\n  color: #d0d0d0 !important;\n  cursor: default !important;\n}\n\n.react-select-item-option:hover {\n  color: #0493D1;\n  background-color: #f4f4f4;\n}\n\n.react-select-item-option-selected {\n  color: #CBD2D7;\n}\n\n.react-select-item-multi .react-select-item-option {\n  padding-left: 42px;\n  position: relative;\n}\n\n.react-select-item-multi .react-select-item-option:before {\n  content: ' ';\n  position: absolute;\n  line-height: 1;\n  text-align: center;\n  left: 20px;\n  top: 9px;\n  border-radius: 3px;\n  height: 12px;\n  width: 12px;\n  margin-right: 10px;\n  border: 1px solid #7B8E9B;\n  background: #f9f9f9;\n  vertical-align: middle;\n}\n\n.react-select-item-multi .react-select-item-option-selected:before {\n  content: '\\2713';\n}\n\n.react-select-item-multi .react-select-item-option-selected {\n  color: #1F3344;\n}\n\n.react-select-item-option:focus,\n.react-select-item-option-focused {\n  color: #0493D1;\n  outline: 0;\n}\n\n.react-select-item-close {\n  color: #0493D1;\n  text-transform: uppercase;\n  background-color: transparent;\n  border: none;\n  padding: 5px 0;\n  display: block;\n  text-align: center;\n  width: 100%;\n  font-weight: bold;\n  cursor: pointer;\n  outline: none;\n}\n\n.react-select-item-close:hover,\n.react-select-item-close:focus {\n  text-decoration: underline;\n}\n\n.react-select-item-empty .react-select-item-close {\n  color: #CBD2D7;\n}\n\n.react-select-item-native {\n  position: absolute;\n  left: -99999em;\n}\n\n.react-select-item-off-screen.no-items {\n  padding-left: 20px;\n  font-size: 12px;\n  color: #7B8E9B;\n  font-weight: bold;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */", "", {"version":3,"sources":["C:/dev/select-item/src/select-item.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sCAAA;CACD;;AAED;EACE,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;CACD;;AAED;EACE,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,oEAAA;EACA,mBAAA;CACD;;AAED;EACE,WAAA;EACA,4BAAA;CACD;;AAED;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,+BAAA;CACD;;AAED;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;EACA,mCAAA;EACA,oCAAA;CACD;;AAED;;EAEE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;CACD;;AAED;EACE,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;CACD;;AAED;EACE,eAAA;CACD;;AAED;EACE,gBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;CACD;;AAED;EACE,mBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;EACA,aAAA;CACD;;AAGD;EACE,eAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;CAAD;;AAGD;;EAEE,WAAA;EACA,gBAAA;CAAD;;AAGD;;EAEE,0BAAA;CAAD;;AAGD;EACE,cAAA;CAAD;;AAGD;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;CAAD;;AAGD;EACE,yBAAA;EACA,UAAA;EACA,WAAA;CAAD;;AAGD;EACE,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;CAAD;;AAED;EACE,oBAAA;EACA,eAAA;CACD;;AAED;EACE,oBAAA;EACA,0BAAA;EACA,2BAAA;CACD;;AAED;EACE,eAAA;EACA,0BAAA;CACD;;AAED;EACE,eAAA;CACD;;AAED;EACE,mBAAA;EACA,mBAAA;CACD;;AAED;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;CACD;;AAED;EACE,iBAAA;CACD;;AAED;EACE,eAAA;CACD;;AAED;;EAEE,eAAA;EACA,WAAA;CACD;;AAED;EACE,eAAA;EACA,0BAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;CACD;;AAED;;EAEE,2BAAA;CACD;;AAED;EACE,eAAA;CACD;;AAED;EACE,mBAAA;EACA,eAAA;CACD;;AAED;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;CACD;AACD,qwRAAqwR","file":"select-item.css","sourcesContent":[".react-select-item-container {\n  position: relative;\n  width: 240px;\n  display: inline-block;\n  background-color: #fff;\n  border-radius: 4px;\n  text-align: left;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .3);\n}\n\n.react-select-item {\n  padding: 15px 0;\n  display: inline-block;\n  cursor: pointer;\n  border: none;\n  width: 100%;\n  text-align: left;\n  background-color: transparent;\n}\n\ninput.react-select-item {\n  box-sizing: border-box;\n  padding-left: 15px;\n  color: #7B8E9B;\n  background: url('assets/search-icon.png') no-repeat scroll 9px 15px;\n  padding-left: 30px;\n}\n\n.react-select-item:focus {\n  outline: 0;\n  box-shadow: 0 0 4px #0493D1;\n}\n\n.react-select-item:before {\n  content: ' ';\n  z-index: 1;\n  position: absolute;\n  height: 20px;\n  top: 15px;\n  right: 34px;\n  border-left: 1px solid #CBD2D7;\n}\n\n.react-select-item:after {\n  content: ' ';\n  position: absolute;\n  z-index: 1;\n  top: 23px;\n  right: 13px;\n  border-top: 6px solid #7B8E9B;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n\n.react-select-item-label,\n.react-select-item-option {\n  line-height: 16px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #7B8E9B;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.react-select-item-label {\n  padding: 0 40px 0 20px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #0493D1;\n}\n\n.react-select-item-empty .react-select-item-label {\n  color: #7B8E9B;\n}\n\n.react-select-item-click-outside-layer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2;\n}\n\n.react-select-item-clear {\n  position: absolute;\n  top: 15px;\n  right: 0;\n  width: 35px;\n  height: 20px;\n  background-color: #fff;\n  text-indent: -9999em;\n  z-index: 3;\n  border: none;\n\n}\n\n.react-select-item-clear:before {\n  content: '×';\n  position: absolute;\n  top: 2px;\n  left: 10px;\n  z-index: 1;\n  background-color: #7B8E9B;\n  border-radius: 100%;\n  font-size: 13px;\n  color: #fff;\n  line-height: 1.1;\n  width: 14px;\n  height: 14px;\n  text-indent: 0;\n  text-align: center;\n}\n\n.react-select-item-clear:hover,\n.react-select-item-clear:focus {\n  outline: 0;\n  cursor: pointer;\n}\n\n.react-select-item-clear:hover:before,\n.react-select-item-clear:focus:before {\n  background-color: #0493D1;\n}\n\n.react-select-item-hidden {\n  display: none\n}\n\n.react-select-item-options {\n  margin: 2px 0 0;\n  position: absolute;\n  padding: 10px 0;\n  width: 240px;\n  top: 100%;\n  left: 0;\n  z-index: 4;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .3);\n}\n\n.react-select-item-options-list {\n  list-style: none outside;\n  margin: 0;\n  padding: 0;\n}\n\n.react-select-item-option {\n  padding: 10px 20px;\n  margin: 0;\n  cursor: pointer;\n  display: block;\n  line-height: 1.2;\n  text-decoration: none;\n}\n.react-select-item-option-disabled {\n  background: #f9f9f9;\n  color: #d0d0d0;\n}\n\n.react-select-item-option-disabled:hover {\n  background: #f9f9f9;\n  color: #d0d0d0 !important;\n  cursor: default !important;\n}\n\n.react-select-item-option:hover {\n  color: #0493D1;\n  background-color: #f4f4f4;\n}\n\n.react-select-item-option-selected {\n  color: #CBD2D7;\n}\n\n.react-select-item-multi .react-select-item-option {\n  padding-left: 42px;\n  position: relative;\n}\n\n.react-select-item-multi .react-select-item-option:before {\n  content: ' ';\n  position: absolute;\n  line-height: 1;\n  text-align: center;\n  left: 20px;\n  top: 9px;\n  border-radius: 3px;\n  height: 12px;\n  width: 12px;\n  margin-right: 10px;\n  border: 1px solid #7B8E9B;\n  background: #f9f9f9;\n  vertical-align: middle;\n}\n\n.react-select-item-multi .react-select-item-option-selected:before {\n  content: '✓';\n}\n\n.react-select-item-multi .react-select-item-option-selected {\n  color: #1F3344;\n}\n\n.react-select-item-option:focus,\n.react-select-item-option-focused {\n  color: #0493D1;\n  outline: 0;\n}\n\n.react-select-item-close {\n  color: #0493D1;\n  text-transform: uppercase;\n  background-color: transparent;\n  border: none;\n  padding: 5px 0;\n  display: block;\n  text-align: center;\n  width: 100%;\n  font-weight: bold;\n  cursor: pointer;\n  outline: none;\n}\n\n.react-select-item-close:hover,\n.react-select-item-close:focus {\n  text-decoration: underline;\n}\n\n.react-select-item-empty .react-select-item-close {\n  color: #CBD2D7;\n}\n\n.react-select-item-native {\n  position: absolute;\n  left: -99999em;\n}\n\n.react-select-item-off-screen.no-items {\n  padding-left: 20px;\n  font-size: 12px;\n  color: #7B8E9B;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "search-icon.png";

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(4);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);
});
//# sourceMappingURL=select-item.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-select-item/dist/select-item.js
// module id = 1284
// module chunks = 0